import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { CaptchaModal } from "../CaptchaModal";
import { StatusModal } from "../StatusModal";
export var ModalController = /*#__PURE__*/memo(function (_ref) {
  var type = _ref.type,
    data = _ref.data;
  if (!data) return null;
  switch (type) {
    case 'captcha':
      return /*#__PURE__*/React.createElement(CaptchaModal, _extends({}, data, {
        "data-t-id": "components-ModalContoller"
      }));
    case 'success':
      return /*#__PURE__*/React.createElement(StatusModal, data);
    case 'error':
      return /*#__PURE__*/React.createElement(StatusModal, data);
    default:
      return null;
  }
});
ModalController.displayName = ModalController.name;